import { Rule } from '../../interfaces/Rule';
import { extractDependsOn } from './utils';

export abstract class BaseRuleset {
  protected rules: Rule[] = [];

  /**
   * It returns all field names that the ruleset depends on.
   *
   * Due to Yup nature, if we have cyclic dependency it throws an exception.
   * Use only the necessary fields to avoid this issue.
   *
   * If you have hit this issue, look at the validation structure and make sure that you don't have the following:
   *
   * Field A depends on Field B, C, D. Field C is depending on Field A.
   */
  public get dependsOn(): string[] {
    return extractDependsOn(this.rules);
  }
}
